import React from 'react'
import styles from './RegisterGoogleSimple.module.css'
import { RegisterGoogleSimpleProps } from './types'
import { useGtm } from '../../../../../../../hooks/useGtm'

export default function RegisterGoogleSimple({
    reasonPoint1Images,
    signupPath,
}: RegisterGoogleSimpleProps) {
    useGtm(['GTM-MJ9GMNND', 'GTM-PZVGNPT'])

    const signupUrl = `/${signupPath}`

    return (
        <>
            <div className={styles.firstView}>
                <header>
                    <img
                        className={styles.firstViewPc}
                        src={'/pages/google/Common/Hotelslabo/Simple/logo_white.png'}
                        alt='Hotelslaboのロゴ'
                    />
                </header>
                <div className={styles.firstViewBox}>
                    <img
                        className={styles.firstViewPc}
                        src={'/pages/google/Common/Hotelslabo/Simple/first_view_pc.png'}
                        alt='ファーストビューのPC画像'
                    />
                    <img
                        className={styles.firstViewTopSp}
                        src={'/pages/google/Common/Hotelslabo/Simple/first_view_top_sp.jpg'}
                        alt='ファーストビューのSP画像'
                    />
                </div>
            </div>

            <div className={styles.entryCta}>
                <a href={signupUrl}>無料登録して求人を見る</a>
            </div>

            <div className={styles.clientCompany}>
                <div className={styles.clientCompanyPc}>
                    <img
                        src={'/pages/google/Common/Hotelslabo/Simple/client_company_pc.jpg'}
                        alt='クライアント企業一覧のPC画像'
                    />
                </div>
                <div className={styles.clientCompanySp}>
                    <img
                        src={'/pages/google/Common/Hotelslabo/Simple/client_company_sp.jpg'}
                        alt='クライアント企業一覧のSP画像'
                    />
                </div>
            </div>

            <section id='reason' className={styles.reason}>
                <div className={styles.reasonPoint1}>
                    <h2>
                        <img
                            src={'/pages/google/Common/Hotelslabo/Simple/reason_point1_h1.png'}
                            alt='POINT1 Hotelslaboだけの限定求人'
                        />
                    </h2>
                    <div className={styles.reasonPoint1Box}>
                        {reasonPoint1Images.map((image, index) => (
                            <img
                                key={index}
                                src={image.src}
                                alt={image.alt}
                            />
                        ))}
                    </div>
                    <div className={styles.entryCta}>
                        <a href={signupUrl}>無料登録して求人を見る</a>
                    </div>
                </div>
            </section>

            <div className={styles.reasonPoint1ContentGroup}>
                <img
                    src={'/pages/google/Common/Hotelslabo/Simple/reason_point1_content_group.png'}
                    alt='POINT1の内容グループの画像'
                />
                <div className={styles.entryCta}>
                    <a href={signupUrl}>無料登録して求人を見る</a>
                </div>
            </div>

            <div id='premium_contents' className={styles.premiumContents}>
                <a href={signupUrl}>
                    <img
                        className={styles.premiumContentsPc}
                        src={'/pages/google/Common/Hotelslabo/Simple/premium_contents_pc.png'}
                        alt='プレミアムコンテンツのPC画像'
                    />
                    <img
                        className={styles.premiumContentsSp}
                        src={'/pages/google/Common/Hotelslabo/Simple/premium_contents_sp.png'}
                        alt='プレミアムコンテンツのSP画像'
                    />
                </a>
            </div>

            <div className={styles.premiumBotann}>
                <div className={styles.entryCta}>
                    <a href={signupUrl}>無料登録してプレミアム会員になる</a>
                </div>
            </div>

            <div className={styles.afterVoice}>
                <img
                    src={'/pages/google/Common/Hotelslabo/Simple/after_voice.png'}
                    alt='「人生を面白くできる転職」してみませんか？'
                />
            </div>

            <footer className={styles.footer}>
                <small>
                    Copyright &copy; {new Date().getFullYear()} Hotelslabo by cuolega All rights reserved.
                </small>
                <div>
                    <a href='https://cuolega.co.jp/privacy/'>プライバシーポリシー</a>
                    <a href='https://cuolega.co.jp/terms/'>利用規約</a>
                    <a href='https://cuolega.co.jp/profile/'>会社概要</a>
                </div>
            </footer>
        </>
    )
}
